import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { TextLoca } from "../../generic/text/TextLoca";
export var UnlockMessageExpansions = function (_a) {
    var requiredLevel = _a.requiredLevel;
    var locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(requiredLevel)]]);
    return (React.createElement("div", { className: "expansion-menu__grid-image-disabled " + IdStyles.BuyExpansionDisabled },
        React.createElement("div", { className: IdStyles.TextBoldSecondary },
            React.createElement(TextLoca, { id: IdLoca.floatingText_expansionDollar, replacements: locaReplacements }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/UnlockMessageExpansions.tsx
// module id = 2870
// module chunks = 3